<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5 class="head_contain">
            <p class="table_card__head--title">
              Generador de QR para vigilante virtual
            </p>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="locations"
          class="elevation-1"
          :items-per-page="10">
          <template slot="items" slot-scope="props" >
            <td @click="editItem(props.item)" style="cursor: zoom-in">
              {{ props.item.attributes.name}}
            </td>
            <td @click="editItem(props.item)" style="cursor: zoom-in" >
              {{ props.item.attributes.virtual_guard_type}}
            </td>
            <td @click="" style="cursor: zoom-in">
              <div
                  style="cursor: pointer"
                  class="virtual_guard__button"
                  @click="generateQRCode(props.item)">
                  <p>Generar QR</p>
              </div>
            </td>
          </template>
        </v-data-table>
        <!-- <p>{{props.item.attributes.users}}</p> -->
        <v-dialog v-model="modal_details" max-width="30%">
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">New Item</v-btn> -->
          <v-card v-if="modal_details" class="table_card">
            <v-card-title class="table_card__head py-3">
              <span class="table_card__head--title">Visualizar counter</span>
            </v-card-title>
            <v-card-text style="padding: 0">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Nombre</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.name}}
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Correo</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 500">
                      {{editedItem.attributes.user.email}}
                    </p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#5A6B8E" flat @click.native="close()">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <qr-modal
      v-if="show_qr_modal"
      :qr_text="qr_value"
      @closeQrModal="resetQrModal()"
    >
    </qr-modal>


  </div>


</template>

<script>
export default {
  data () {
    return {
      show_qr_modal: false,
      qr_value: '',
      page: 1,
      modal_details: false,
      locations: [],
      headers: [
          { text: 'Nombre Locación', value: 'name', sortable: false },
          { text: 'Tipo de Vigilante Virtual', sortable: false, value: 'virtual_guard_type' },
      ],
      editedItem: {
        attributes:{
          id:'',
          name: '',
          email: []
        }
      },
      defaultItem: {
        attributes:{
          id:'',
          name: '',
          email: []
        }
      },
      editedIndex: -1,
      locationType:'',
      locationArray:[]
    }
  },
  mounted(){
    this.findLocations();
  },
  methods: {
    resetQrModal(){
      this.show_qr_modal = false;
    },
    findLocations(){
      let params = { page: this.page }
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
           params
        })
        .then(function(response){
          this.locations = response.body.data.filter(location => location.attributes.published == true)
          console.log('======log========')
          console.log(response.body.data);
          this.pages = response.body.meta.pages
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    generateQRCode(obj){
      if (obj.attributes.virtual_guard_type == 'Abierto') {
        this.qr_value = "https://access.fusepong.com/#/?id="+obj.attributes.company_id.toString()+"&location_id="+obj.id.toString()+"&sublocation_id="+(obj.attributes.sublocation_employee ? obj.attributes.sublocation_employee.id.toString() : "")
      } else {
        this.qr_value = "https://access.fusepong.com/#/?id="+obj.attributes.company_id.toString()+"&location_id="+obj.id.toString()
      }
      this.show_qr_modal = true
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/components/views/access/VirtualGuardQRGenerator.vue